// Curated gallery images - import explicitly to avoid showing images used elsewhere

import jOne from "../assets/jOne.jpg";
import jTwo from "../assets/jTwo.jpg";
import jThree from "../assets/jThree.jpg";
import jFour from "../assets/jFour.jpg";
// import jFive from "../assets/jFive.jpg";
import jNine from "../assets/jNine.jpeg";
import jTen from "../assets/jTen.jpeg";
import jEleven from "../assets/jEleven.jpeg";
import jSixteen from "../assets/jSixteen.jpg";
import DNP8 from "../assets/DNP8.jpeg";
import DNP27 from "../assets/DNP27.jpeg";
import DNP32 from "../assets/DNP32.jpeg";
import DNP36 from "../assets/DNP36.jpeg";
import DNP44 from "../assets/DNP44.jpeg";
import DNP50 from "../assets/DNP50.jpeg";

const IMAGES = [
  { src: DNP44, name: "DNP44" },
  { src: jOne, name: "San Diego @ Maverick's" },
  { src: jTwo, name: "San Diego @ Sycamore Den" },
  { src: DNP32, name: "DNP32" },
  { src: jFour, name: "San Diego @ Mavericks's" },
  // { src: jFive, name: "jFive.jpg" },
  { src: jNine, name: "San Diego @ Mavericks's" },
  { src: jTen, name: "San Diego @ Mavericks's" },
  { src: jSixteen, name: "Jose 3" },
  { src: DNP8, name: "DNP8" },
  { src: DNP36, name: "DNP36" },
  { src: jThree, name: "San Diego @ Sycamore Den" },
  { src: DNP50, name: "DNP50" },
  { src: jEleven, name: "San Diego @ Sycamore Den" },
  { src: DNP27, name: "DNP27" }
];

export default IMAGES;
